import styled from "styled-components";

export const Article = styled.div`
    grid-area: article;
    background-color: white;
    border-radius: 40px 40px 0 0;
    display: grid;
    margin-top: 60px;
    padding: 30px 30px 0 30px;
    align-self: baseline;
    z-index: 10;
    @media (max-width: 1240px) {
        margin-top: 38px;
        padding: 47px 20px 0 20px;
        border-bottom: 1px solid white;
        border-radius: 40px;
    }
`;

export const FirstArticle = styled.div`
    grid-area: article;
    background-color: white;
    border-radius: 40px;
    display: grid;
    margin-top: 60px;
    margin-bottom: 60px;
    padding: 30px 30px 30px 30px;
    align-self: baseline;
    z-index: 10;
    @media (max-width: 1240px) {
        margin-top: 38px;
        padding: 47px 20px 40px 20px;
        border-bottom: 1px solid white;
    }
`;

export const ArticleSpace = styled.div`
    grid-area: article;
    background-color: white;
    border-radius: 40px;
    display: grid;
    margin-top: 60px;
    margin-bottom: 60px;
    align-self: baseline;
    z-index: 10;
    @media (max-width: 1240px) {
        margin-top: 38px;
        padding: 47px 20px 40px 20px;
        border-bottom: 1px solid white;
    }
`;

export const ArticleLayout = styled.div`
    padding: 30px 30px 30px 30px;
`;

export const Header = styled.div`
    display: grid;
    height: min-content;
    grid-auto-flow: column;
    @media (max-width: 1240px) {
        grid-auto-flow: row;
        grid-gap: 20px;
    }
`;

export const Author = styled.div`
    display: grid;
    grid-template-areas:
        "avatar fullname"
        "avatar post";
    justify-content: flex-start;
    grid-gap: 0 10px;
`;

export const AuthorAvatar = styled.img`
    border-radius: 50%;
    width: 40px;
    grid-area: avatar;
`;

export const AuthorName = styled.div`
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: rgb(0, 0, 0, 0.85);
    grid-area: fullname;
`;

export const AuthorPost = styled.div`
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: rgb(0, 0, 0, 0.5);
    grid-area: post;
`;

export const AuthorPubDate = styled.div`
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    text-align: right;
    color: #e38146;
    align-self: center;
    @media (max-width: 1240px) {
        text-align: left;
    }
`;

export const Content = styled.div`
    padding-top: 10px;
    @media (max-width: 1240px) {
        padding-top: 0;
    }
`;

export const ContentTitle = styled.h3`
    font-weight: 600;
    font-size: 48px;
    line-height: 60px;
    /* identical to box height */
    color: #082e99;
    line-height: 125%;
    margin: 45px 5px 30px 0;
    max-width: 90%;
    @media (max-width: 1240px) {
        font-size: 36px;
        line-height: 45px;
        margin: 40px 5px 30px 0;
    }
`;

export const ContentSubTitle = styled.h4`
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 153%;
    color: #216ddb;
    padding-right: 2px;
    margin: 20px 0 10px 0;
    max-width: 90%;
`;

export const ArticleText = styled.p`
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    margin: 0;
    max-width: 90%;
    color: rgba(0, 0, 0, 0.85);
    @media (max-width: 1240px) {
        font-weight: 400;
        font-size: 18px;
        line-height: 140%;
        max-width: 100%;
    }
`;

export const ArticleLink = styled.a`
    color: #e38146;
`;

export const ArticleImage = styled.img`
    height: 350px;
    width: 100%;
    background: #f9f1dc;
    border-radius: 40px;
    margin: 60px 0;
    @media (max-width: 1240px) {
        height: 200px;
        margin: 30px 0 60px 0;
    }
`;

export const FirstArticleImage = styled.img`
    height: auto;
    width: 100%;
    margin: 40px 0;
    @media (max-width: 1240px) {
        margin: 30px 0 60px 0;
    }
`;
